import { MissionCompletionData } from '../types/mission';
import { SequenceChallengeResult } from '../components/chess/SequenceChallenge';

export const createCoordinateCompletionData = (
  success: boolean,
  score: number,
  accuracy: number,
  timeSpent: number
): MissionCompletionData => ({
  success,
  score,
  accuracy,
  timeSpent,
  movesUsed: 0,
  hintsUsed: 0,
});

export const createMoveCompletionData = (
  success: boolean,
  score: number,
  accuracy: number,
  timeSpent: number,
  hintsUsed: number,
  movesUsed: number
): MissionCompletionData => ({
  success,
  score: Math.max(0, Math.min(100, Math.round(score))),
  accuracy: Math.max(0, Math.min(100, Number(accuracy.toFixed(1)))),
  timeSpent,
  movesUsed,
  hintsUsed,
});

export const createSequenceCompletionData = (
  result: SequenceChallengeResult
): MissionCompletionData => ({
  success: result.success,
  score: result.score,
  // Sequence score already incorporates execution quality and penalties.
  accuracy: Math.max(0, Math.min(100, Math.round(result.score))),
  timeSpent: result.timeSpent,
  movesUsed: result.moves.length,
  hintsUsed: 0,
});
